import { Heading } from 'components/Heading';
import {
  CheckMarkLinear,
  OpenIcon,
  PersonAdd,
  PersonBlock,
  PersonClockRed,
  PersonPrivate,
  SitesAdd,
  Suport,
} from 'components/Icons';

import * as S from './styles';

import { useContext, useEffect, useMemo, useState } from 'react';
import { api } from 'services/api';
import { Loading } from 'components/Loading';
import moment from 'moment';
import 'moment/locale/pt-br';
import { MainHeader } from 'components/MainHeader';
import { BaseMain } from 'components/BaseMain';

import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { BaseContentMain } from 'components/BaseContentMain';
import DetailsImob from './Drawer/DetailsImob';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import { buildPlanPrice } from 'helpers/util';
export const formatCurrency = (value: number) => {
  try {
    if (Number.isNaN(Number(value))) {
      throw new Error('Invalid money value');
    }
    const formatMoney = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
    return formatMoney.format(value).replace(/\s/, ' ');
  } catch (e: any) {
    return e.message;
  }
};
export type DataProps = {
  totalCost: string;
  discountValue: string;
  installmentAmount: number;
  totalUserCount: number;
  maxUserCount: number;
  frequency: string;
  startTrialDate: string;
  activationDate: string;
  terminationDate: string;
  id_client: string;
  name: string;
  typeProduct: string;
  totalLeasingContractCount: string;
  finalValue: string;
};

export type PlanDetailsProps = {
  activationDate: string;
  totalUserCount: number;
  maxUserCount: number;
  totalUserExtra: number;
  costUserExtra: number | undefined;
  totalCostUserExtra: number | undefined;
  frequency: string;
  startTrialDate: string;
  terminationDate: string;
  name: string;
  id_plan: number;
  id_client: string;
  plan: {
    name: string;
  };
  status: string;
  typeProduct: string;
  totalLeasingContractCount: string;
  totalCost?: string;
  finalValue?: string;
};

export type PlanDetailsValuesProps = {
  activationDate: string;
  terminationDate: string;
  additionalUserCost: string;
  frequency: string;
  totalCost: string;
  discountValue: string;
  finalValue: string;
  installmentAmount: number;
  installmentValue: string;
  status: string;
  typeProduct: string;
  type_payment: {
    description: string;
  };
};

export const PlanDetails = () => {
  const [planDetails, setPlanDetails] = useState<PlanDetailsProps | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const imobUrl = process.env.REACT_APP_URL_IMOB;

  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const history = useCustomUtilsHistory();
  const { dataClientInfo } = useContext(ClientInfoContext);

  const [isLoading, setIsLoading] = useState(false);
  //eslint-disable-next-line
  const [typeProduct, setTypeProduct] = useState('');
  const imobId = localStorage.getItem('company_id');
  const [indicators, setIndicators] = useState<any>();
  const [indicatorsInfors, setIndicatorsInfors] = useState<any>();
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const fetchDataChangePlan = async () => {
      try {
        const { data } = await api.get(
          `/kernel/additional-users/${dataClientInfo?.id_realstate}
        `,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setIsLoading(true);
        setIndicators(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataChangePlan();
  }, [accessToken, idToken, dataClientInfo?.id_realstate]);
  const [inforImob, setInforImob] = useState<any>();

  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/signatures/${inforImob?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setPlanDetails(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    inforImob?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, inforImob?.id_signature]);
  useEffect(() => {
    const fetchComplementaryProducts = async () => {
      try {
        const { data } = await api.get('products', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setInforImob(data.data.find((el: any) => el.id === 1));
      } catch (error) {
        console.log(error);
      }
    };
    fetchComplementaryProducts();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchIndicators = async () => {
      try {
        const { data } = await api.get(
          `/indicators/${dataClientInfo?.id_realstate}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        dataClientInfo?.id_realstate && setIndicatorsInfors(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    imobId && fetchIndicators();
  }, [accessToken, idToken, imobId, dataClientInfo?.id_realstate]);
  const safeCount = (count: any) => count ?? 0;
  const pluralize = (count: any, word: any) => {
    return count > 1 ? `${word}s` : word;
  };
  const pluralizeSubTitle = (count = 0, word: any) => {
    return count > 1 ? `não acessaram nest${word}` : `não acessou nest${word}`;
  };

  const infors = [
    {
      icon: <PersonClockRed />,
      title:
        safeCount(indicatorsInfors?.no_single_accesses_week) > 0
          ? `${indicatorsInfors?.no_single_accesses_week} ${pluralize(
              indicatorsInfors?.no_single_accesses_week,
              'usuário',
            )}`
          : 'Nenhum usuário',
      subTitle: `${pluralizeSubTitle(
        safeCount(indicatorsInfors?.no_single_accesses_week),
        'a semana',
      )}`,
    },
    {
      icon: <PersonPrivate />,
      title:
        safeCount(indicatorsInfors?.no_single_accesses_month) > 0
          ? `${indicatorsInfors?.no_single_accesses_month} ${pluralize(
              indicatorsInfors?.no_single_accesses_month,
              'usuário',
            )}`
          : 'Nenhum usuário',
      subTitle: `${pluralizeSubTitle(
        safeCount(indicatorsInfors?.no_single_accesses_month),
        'e mês',
      )}`,
    },
    {
      icon: <PersonBlock />,
      title:
        safeCount(indicatorsInfors?.no_single_accesses) > 0
          ? `${indicatorsInfors?.no_single_accesses} ${pluralize(
              indicatorsInfors?.no_single_accesses,
              'usuário',
            )}`
          : 'Nenhum usuário',
      subTitle: `${
        indicatorsInfors?.no_single_accesses > 1
          ? 'nunca acessaram o sistema'
          : 'nunca acessou o sistema'
      }`,
    },
  ];
  const percentage = useMemo(() => {
    if (
      indicatorsInfors?.single_accesses_week != null &&
      indicators?.contract_users != null &&
      indicators?.additional_users != null
    ) {
      return (
        (indicatorsInfors.single_accesses_week * 100) /
        (indicators?.contract_users + indicators?.additional_users)
      );
    }

    return 0;
  }, [
    indicatorsInfors?.single_accesses_week,
    indicators?.contract_users,
    indicators?.additional_users,
  ]);

  const planPrice = buildPlanPrice(
    inforImob?.planFrequency,
    inforImob?.installmentValue,
    planDetails,
  );

  return (
    <>
      <MainHeader />
      <SubHeader
        title="Detalhes do Produto"
        onReturn={() => history.push('/ClientArea')}
      />
      {!isLoading && <Loading />}
      <BaseMain hideHeader>
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              <S.TitleAside>
                <span className="title">Kenlo Imob</span>
                <InvoiceStatus
                  status={inforImob?.status === 'ativo' ? 'paga' : 'cancelada'}
                  text={inforImob?.status === 'ativo' ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>
              <S.TitleAside>
                <S.TextAside>Total de usuários</S.TextAside>
                <span className="title">
                  {indicators?.contract_users + indicators?.additional_users}{' '}
                </span>
              </S.TitleAside>
              <hr
                style={{
                  marginLeft: '-24px',
                  marginRight: '-24px',
                  marginBottom: '24px',
                }}
              />
              <S.TitleAside>
                <S.TextAside fontWeight="700">Cobrança</S.TextAside>
              </S.TitleAside>
              <S.Grid>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de contratação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(inforImob?.activationDate).format('DD/MM/YYYY')}
                  </S.TextAside>
                </div>{' '}
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de renovação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(planDetails?.terminationDate)
                      .startOf('month')
                      .format('D[º] [de] MMMM [de] YYYY')}
                  </S.TextAside>
                </div>
              </S.Grid>

              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Valor
                </S.TextAside>
                <S.TextAside fontSize="20">
                  {formatCurrency(planPrice.value) || '0,00'}
                  {planPrice.period ? ` / ${planPrice.period}` : ''}
                </S.TextAside>
              </div>
              <div
                style={{
                  borderTop: '1px solid #F2F2F2',
                  padding: '8px',
                  alignItems: 'center',
                  marginTop: '16px',
                  marginBottom: '0px',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '16px',
                }}
                onClick={() => setOpenDrawer(true)}
              >
                <S.TextAside
                  fontSize="16"
                  color="#298ee6"
                  fontWeight="700"
                  style={{ cursor: 'pointer' }}
                >
                  Ver detalhes
                </S.TextAside>
              </div>
            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            <S.contentAside>
              <S.TitleAside>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <S.Circle percentage={`${percentage}`}>
                    {percentage >= 100 && <CheckMarkLinear />}
                  </S.Circle>

                  <div>
                    <S.TextAside fontSize="32" fontWeight="700">
                      {indicatorsInfors?.single_accesses_week || 0} usuários
                    </S.TextAside>
                    <S.TextAside
                      fontSize="16"
                      color="#808080"
                      style={{ marginTop: '8px' }}
                    >
                      acessaram nos útimos 7 dias
                    </S.TextAside>
                  </div>
                </div>
                {!isMobile && (
                  <S.TextAside
                    fontSize="16"
                    color="#298ee6"
                    fontWeight="700"
                    cursor
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                    onClick={() =>
                      window.open(
                        `${imobUrl}/admin/default.aspx#/new-digital-rent`,
                        '_blank',
                      )
                    }
                  >
                    <OpenIcon color="#298ee6" />
                    Gerenciar
                  </S.TextAside>
                )}
              </S.TitleAside>
              <hr style={{ margin: ' 0 -24px ' }} />
              <S.GridInfos>
                {infors.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {el.icon}
                    <div>
                      <S.TextAside fontSize="16" fontWeight="700">
                        {el.title}
                      </S.TextAside>
                      <S.TextAside fontSize="12" color="#808080">
                        {el.subTitle}
                      </S.TextAside>
                    </div>
                  </div>
                ))}
              </S.GridInfos>
            </S.contentAside>
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Serviços adicionais"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                </S.WrapperTitle>
              }
            >
              <>
                <div
                  style={{
                    padding: '16px',
                    border: '1px solid #D8D8D8',
                    borderRadius: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <PersonAdd />
                    <S.TextAside fontSize="16" fontWeight="700">
                      Usuários
                    </S.TextAside>
                  </div>
                  <div>
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="500"
                      color=" #808080"
                    >
                      Acesse a{' '}
                      <S.TextCustom
                        fontSize="16"
                        fontWeight="700"
                        color="#298ee6"
                        cursor
                        onClick={() =>
                          window.open(
                            `${imobUrl}/admin/default.aspx#/modules/account_manager/usuarios/usuarios.aspx`,
                            '_blank',
                          )
                        }
                      >
                        gestão de usuários
                      </S.TextCustom>{' '}
                      no Kenlo Imob e clique em “Adicionar usuário” para
                      configurá-lo. O sistema identificará a cobrança que virá
                      na próxima fatura.
                    </S.TextCustom>
                  </div>
                </div>
                <div
                  style={{
                    padding: '16px',
                    border: '1px solid #D8D8D8',
                    borderRadius: '12px',
                    marginTop: '16px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <SitesAdd />
                    <S.TextAside fontSize="16" fontWeight="700">
                      Sites
                    </S.TextAside>
                  </div>
                  <div>
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="500"
                      color=" #808080"
                    >
                      Acesse a{' '}
                      <S.TextCustom
                        fontSize="16"
                        fontWeight="700"
                        color="#298ee6"
                        cursor
                        onClick={() =>
                          window.open(
                            `${imobUrl}/admin/default.aspx#/cms/analytics`,
                            '_blank',
                          )
                        }
                      >
                        painel do Kenlo Sites
                      </S.TextCustom>
                      ,clique no seletor do site no canto superior esquerdo e
                      após no botão “Criar novo site”. O sistema identificará a
                      cobrança que virá na próxima fatura.
                    </S.TextCustom>
                  </div>
                </div>
              </>
            </BaseContentMain>
            <S.contentAside>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '24px',
                  flexDirection: isMobile ? 'column' : 'row',
                }}
              >
                <Suport />
                <div>
                  <S.TextAside fontSize="16" fontWeight="700">
                    Tire suas dúvidas do Kenlo Imob
                  </S.TextAside>
                  <S.TextCustom fontSize="16" fontWeight="500" color=" #808080">
                    Você pode{' '}
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="700"
                      color="#298ee6"
                      cursor
                      onClick={() => window.fcWidget.open()}
                    >
                      entrar em contato
                    </S.TextCustom>{' '}
                    pelo balão flutuante em qualquer lugar do sistema ou
                    verificar se já tem resposta para sua dúvida na
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="700"
                      color="#298ee6"
                      cursor
                      onClick={() =>
                        window.open(
                          `https://fresh.kenlo.com.br/support/solutions/156000101600`,
                          '_blank',
                        )
                      }
                    >
                      {' '}
                      base de conhecimento.
                    </S.TextCustom>
                  </S.TextCustom>
                </div>
              </div>
            </S.contentAside>
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
      {openDrawer && (
        <DetailsImob
          closeDrawer={() => setOpenDrawer(false)}
          inforImob={{
            ...inforImob,
            terminationDate: moment(planDetails?.terminationDate)
              .startOf('month')
              .format('D[º] [de] MMMM [de] YYYY'),
          }}
        />
      )}
    </>
  );
};
